import pages from '../screens/all-pages';

export const ROUTE_LOGIN = 'https://central.zetta-system.com';
export const ROUTE_LOGIN_MANUAL = '/account/login';
export const ROUTE_HANDLE = '/account/handle';

export const KEY_ROUTE_MAIN = '@ROUTES/ROUTE_MAIN';
export const KEY_ROUTE_HOME = '@ROUTES/ROUTE_HOME';
export const KEY_ROUTE_REGISTER = '@ROUTES/ROUTE_REGISTER';
export const KEY_ROUTE_HOME_SCENE = '@ROUTES/ROUTE_HOME_SCENE';
export const KEY_ROUTE_PROFILE_SCENE = '@ROUTES/ROUTE_PROFILE_SCENE';
export const KEY_ROUTE_REGISTER_TELEPHONE = '@ROUTES/ROUTE_REGISTER_TELEPHONE';
export const KEY_ROUTE_CLAIM_REGISTER = '@ROUTES/ROUTE_CLAIM_REGISTER';
export const KEY_ROUTE_REGISTER_INFO = '@ROUTES/ROUTE_REGISTER_INFO';
export const KEY_ROUTE_TERM_WARRANTY = '@ROUTES/ROUTE_TERM_WARRANTY';

export const ROUTES_PATH = {
  ROUTE_MAIN: {
    KEY: KEY_ROUTE_MAIN,
    PATH: '/',
    LABEL: 'หน้าหลัก',
    COMPONENT: pages.HomeScene,
  },
  ROUTE_HOME: {
    KEY: KEY_ROUTE_HOME,
    PATH: '/home',
    LABEL: 'หน้าหลัก',
    COMPONENT: pages.HomeScene,
  },
  ROUTE_REGISTER: {
    KEY: KEY_ROUTE_REGISTER,
    PATH: '/register/warranty',
    LABEL: 'หน้าหลัก',
    COMPONENT: pages.Register,
  },
  ROUTE_PROFILE: {
    KEY: KEY_ROUTE_PROFILE_SCENE,
    PATH: '/profile',
    LABEL: 'หน้าหลัก',
    COMPONENT: pages.ProfileScene,
  },
  ROUTE_REGISTER_TELEPHONE: {
    KEY: KEY_ROUTE_REGISTER_TELEPHONE,
    PATH: '/register/telephone',
    LABEL: 'ลงทะเบียนเบอร์มือถือ',
    COMPONENT: pages.RegisterTelScene,
  },
  ROUTE_CLAIM_REGISTER: {
    KEY: KEY_ROUTE_CLAIM_REGISTER,
    PATH: '/claim/register',
    LABEL: 'ลงทะเบียนเคลม',
    COMPONENT: pages.ClaimScene,
  },
  ROUTE_REGISTER_INFO: {
    KEY: KEY_ROUTE_REGISTER_INFO,
    PATH: '/register-info',
    LABEL: 'register-info',
    COMPONENT: pages.RegisterInfo,
  },
  ROUTE_TERM_WARRANTY: {
    KEY: KEY_ROUTE_TERM_WARRANTY,
    PATH: '/term/warranty',
    LABEL: 'ข้อตกลงการรับประกันสินค้า',
    COMPONENT: pages.TermWarranty,
  },
};

function getKeyLowerCase(obj) {
  return Object.fromEntries(Object.entries(obj).map(([k, v]) => [k.toLowerCase(), v]));
}

export const ROUTES_MENU = [getKeyLowerCase(ROUTES_PATH.ROUTE_REGISTER)];

export const FULLSCEEN_ROUTES = [ROUTES_PATH.ROUTE_PROFILE.KEY];
